import { apiBaseUrl, spevalApi } from 'yxt-biz-pc/packages/api';

let baseUrl = apiBaseUrl;
let apiTalent = 'sptalentsd';

spevalApi.defaults.headers['x-yxt-product'] = 'sp';

// 报告库项目维度 导入人员数据模板
export const reportsProjectPeopleTemplate = data => {
  return spevalApi.post(`/mgr/report/peopleTemplate/${data.evaId}`, data);
};

export const getModelIdsByEvalId = (evalId) => {
  return spevalApi.get(`/mgr/evaluations/${evalId}`);
};

// 批量查询模型ids
export const getModelNameByIds = (ids) => {
  return baseUrl.post(`${apiTalent}/mgr/model/studyconfig/skillmodel`, {
    skillModelIds: ids
  });
};

export const reportsProjectPeopleImprot = (params, body) => {
  return spevalApi.post('/mgr/evaluations/import/third/party', body, { params });
};
